module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Anubhav Kumar","short_name":"AnubhavKumar","start_url":"/","background_color":"#161718","theme_color":"#6937FF","display":"minimal-ui","icon":"src/images/icons/favicon.svg","theme_color_in_head":false,"legacy":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"ff893d5905c36928611735f5f1f80b67"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
